class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", {
        bubbles: !0,
      })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      ));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange() {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ||
    event.target.closest("button").name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown(),
      previousValue !== this.input.value &&
        this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        value <= min
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle(
        "disabled",
        value >= max
      );
    }
  }
}
customElements.define("quantity-input", QuantityInput);
class VariantSwatches extends HTMLElement {
  constructor() {
    super(),
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.init();
  }
  init() {
    const _this = this;
    this.querySelectorAll(".swatch-items-js").forEach((btn) => {
      _this.checkSwatches(btn),
        btn.addEventListener("click", this.onVariantChange.bind(this), !1);
    }),
      this.showColorSwatch();
  }
  showColorSwatch() {
    const _this = this,
      show_color_swatch = this.querySelector(".show-color-swatch-js");
    show_color_swatch?.addEventListener("click", (e) => {
      e.currentTarget.classList.add("hidden"),
        _this.querySelectorAll(".swatch-items-js.hidden").forEach((btn) => {
          btn.classList.remove("hidden"),
            setTimeout(() => {
              btn.classList.remove("opacity-0");
            }, 100);
        });
    });
  }
  async updateVariantsSwatch(target) {
    const _this = this,
      sectionId = _this.dataset.section,
      url = _this.dataset.url;
    this.productTarget = target.closest(".product__item-js");
    const optionSelect = Array.from(
        this.productTarget.querySelectorAll(".swatch-items-js.active"),
        (select) => select.getAttribute("data-option-value-id")
      ),
      params =
        optionSelect.length > 0
          ? sectionId
            ? `&option_values=${optionSelect.join(",")}`
            : `?option_values=${optionSelect.join(",")}`
          : "",
      fetchUrl = sectionId
        ? `${url}?section_id=${sectionId}${params}`
        : `${url}${params}`;
    await fetch(`${fetchUrl}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        _this.querySelector(".variantItemJson")
          ? (_this.querySelector(".variantItemJson").innerHTML =
              html.querySelector(".variantJson").innerHTML)
          : ((_this.querySelector(".variantJson").innerHTML =
              html.querySelector(".variantJson").innerHTML),
            (this.productTarget.querySelector(
              ".product__submit-form-js"
            ).innerHTML = html.querySelector(
              ".product__submit-form-js"
            ).innerHTML));
      }),
      (this.variantData = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      ));
  }
  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    (this.productTarget = target.closest(".product__item-js")),
      (this.position_swatch = target.getAttribute("data-position"));
    const type_swatch = "item";
    if (!target.classList.contains("active")) {
      target
        .closest(".product-swatches-js")
        .querySelectorAll(".swatch-items-js")
        .forEach((el) => {
          el.classList.remove("active");
        }),
        target.classList.toggle("active"),
        await this.updateVariantsSwatch(target);
      const variantQtyData = JSON.parse(
        this.productTarget.querySelector(".productVariantsQty").textContent
      );
      this.updateOptions(),
        this.updateMasterId(this.variantData) &&
          (this.updateMedia(type_swatch),
          this.updatePrice(this.productTarget),
          this.renderProductInfor(variantQtyData),
          this.updateShareUrl());
    }
  }
  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    !shareButton ||
      !shareButton.updateUrl ||
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateURL() {
    !this.currentVariant ||
      this.dataset.updateUrl === "false" ||
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateOptions() {
    (this.options = Array.from(
      this.productTarget.querySelectorAll(".swatch-items-js.active"),
      (select) => select.getAttribute("data-value")
    )),
      this.variantData.find((variant) => {
        this.options.length == 1 &&
          {
            1: variant.option1,
            2: variant.option2,
            3: variant.option3,
          }[this.position_swatch] === this.options[0] &&
          (this.options = variant.options);
      });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(!1)
    ));
  }
  updateMedia() {
    if (
      this.currentVariant &&
      this.currentVariant.featured_media &&
      (this.productTarget.querySelector(".product__media img") &&
        this.productTarget
          .querySelector(".product__media img")
          .removeAttribute("srcset"),
      this.productTarget.querySelector(".product__media img") &&
        this.productTarget
          .querySelector(".product__media img")
          .setAttribute(
            "src",
            this.currentVariant.featured_media.preview_image.src
          ),
      this.productTarget.querySelector(".product__media.animation-swatches"))
    ) {
      this.productTarget
        .querySelector(".product__media.animation-swatches")
        .classList.add("skeleton-box");
      var img = new Image();
      const _this = this;
      (img.src = this.currentVariant.featured_media.preview_image.src),
        img.addEventListener("load", function () {
          setTimeout(() => {
            _this.productTarget
              .querySelector(".product__media.animation-swatches")
              .classList.remove("skeleton-box");
          }, 1e3);
        });
    }
  }
  updatePrice(productTarget) {
    if (!this.currentVariant || !productTarget) return;
    const p = document.getElementById(`price-${this.dataset.section}`);
    p && p.classList.remove("visibility-hidden");
    const compare_at_price = this.currentVariant.compare_at_price,
      price = this.currentVariant.price,
      unit_price = this.currentVariant.unit_price,
      unit_price_measurement = this.currentVariant.unit_price_measurement,
      price_format = Shopify.formatMoney(
        this.currentVariant.price,
        themeGlobalVariables.settings.money_format
      );
    if (unit_price && unit_price_measurement) {
      const price_num = Shopify.formatMoney(
          unit_price,
          themeGlobalVariables.settings.money_format
        ),
        price_unit =
          unit_price_measurement.reference_value != 1
            ? unit_price_measurement.reference_value
            : unit_price_measurement.reference_unit;
      productTarget.querySelector(".unit-price .number") &&
        (productTarget.querySelector(".unit-price .number").innerHTML =
          price_num),
        productTarget.querySelector(".unit-price .unit") &&
          (productTarget.querySelector(".unit-price .unit").innerHTML =
            price_unit);
    }
    productTarget.querySelector(".price-regular .price") &&
      (productTarget.querySelector(".price-regular .price").innerHTML =
        price_format);
    const bls__price = productTarget.querySelector(".card-product-price");
    if (bls__price) {
      if (!bls__price.querySelector(".compare-price")) {
        var ps = document.createElement("div"),
          sp = document.createElement("span"),
          cp = document.createElement("s");
        cp.classList.add("price-item", "compare-price"),
          sp.appendChild(cp),
          ps.appendChild(sp),
          ps.classList.add("price-sale"),
          productTarget.querySelector(".card-product-price") &&
            productTarget.querySelector(".card-product-price").appendChild(ps);
      }
      const cpp = bls__price.querySelector(".compare-price");
      if (cpp) {
        if (compare_at_price && compare_at_price > price) {
          const compare_format = Shopify.formatMoney(
            compare_at_price,
            themeGlobalVariables.settings.money_format
          );
          (cpp.innerHTML = compare_format),
            bls__price.querySelector(".price-regular .price") &&
              bls__price
                .querySelector(".price-regular .price")
                .classList.add("special-price");
        } else
          (cpp.innerHTML = ""),
            bls__price.querySelector(".price-regular .price") &&
              (bls__price
                .querySelector(".price-regular .price")
                .classList.remove("special-price"),
              (bls__price.querySelector(".price-regular .price").innerHTML =
                price_format));
        this.currentVariant.available ||
          bls__price.classList.add("price--sold-out");
      }
    }
  }
  renderLabel(sale, pre_order, soldOut, percent) {
    if (
      (sale || pre_order || soldOut) &&
      !this.productTarget.querySelector(".product__badges")
    ) {
      var element = document.createElement("div");
      element.classList.add(
        "product__badges",
        "fs-small",
        "absolute",
        "d-flex",
        "flex-wrap",
        "uppercase"
      ),
        this.productTarget.querySelector(".product__inner a") &&
          this.productTarget
            .querySelector(".product__inner a")
            .appendChild(element);
    }
    const label = this.productTarget.querySelector(".product__badges"),
      show_badges = this.productTarget.dataset.showBadges;
    if (label && show_badges !== "false") {
      const dsale = label.querySelector(".product__badges-sale"),
        dsoldout = label.querySelector(".product__badges-sold-out"),
        dpreorder = label.querySelector(".product__badges-pre-order");
      if (sale)
        if (dsale) dsale.innerHTML = `${percent.toFixed(0)}% OFF`;
        else {
          var elementsale = document.createElement("div");
          elementsale.classList.add(
            "product__badges-sale",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementsale.innerHTML = `${percent.toFixed(0)}% OFF`),
            dsoldout
              ? label.insertBefore(elementsale, dsoldout)
              : dpreorder
              ? label.insertBefore(elementsale, dpreorder)
              : label.appendChild(elementsale);
        }
      else dsale && dsale.remove();
      if (pre_order)
        if (dpreorder)
          dpreorder.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : "Pre-order";
        else {
          var elementpo = document.createElement("div");
          elementpo.classList.add(
            "product__badges-pre-order",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementpo.innerHTML = window.variantStrings.preOrder
              ? window.variantStrings.preOrder
              : "Pre-order"),
            label.appendChild(elementpo);
        }
      else dpreorder && dpreorder.remove();
      if (soldOut)
        if (dsoldout)
          dsoldout.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : "Sold out";
        else {
          var elementso = document.createElement("div");
          elementso.classList.add(
            "product__badges-sold-out",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementso.innerHTML = window.variantStrings.soldOut
              ? window.variantStrings.soldOut
              : "Sold out"),
            label.appendChild(elementso);
        }
      else dsoldout && dsoldout.remove();
    }
  }
  updateIncomingStatus(productTarget, variantQtyData) {
    if (!variantQtyData || !productTarget || !this.currentVariant) return;
    let date = "",
      is_coming = !1;
    variantQtyData
      .reduce((acc, item) => {
        const existingItem = acc.find((i) => i.option === item.option);
        return (
          existingItem
            ? ((existingItem.incoming_date = item.incoming_date),
              item.incoming === !0 && (existingItem.incoming = !0))
            : acc.push(item),
          acc
        );
      }, [])
      .find((variantQty) => {
        variantQty.option === this.currentVariant.option1 &&
          ((is_coming = variantQty.incoming),
          (date = variantQty.incoming_date));
      });
    const inventory_status = productTarget.querySelector(".inventory_status");
    if (inventory_status) {
      const divMessage = inventory_status.querySelector(".incoming-message");
      var options = {
          month: "long",
          day: "numeric",
          year: "numeric",
        },
        dateObj = new Date(date),
        formattedDate = dateObj.toLocaleDateString("en-US", options);
      if (divMessage)
        is_coming === "true"
          ? date
            ? (divMessage.innerHTML = window.variantStrings.incoming_with_date
                ? window.variantStrings.incoming_with_date.replace(
                    "{{ date }}",
                    formattedDate
                  )
                : "The stock will arrive on " + formattedDate)
            : (divMessage.innerHTML = window.variantStrings.incoming
                ? window.variantStrings.incoming
                : "Stock in transit")
          : divMessage.remove();
      else if (is_coming === "true") {
        var elementso = document.createElement("div");
        elementso.classList.add("incoming-message", "mb-10"),
          date
            ? (elementso.innerHTML = window.variantStrings.incoming_with_date
                ? window.variantStrings.incoming_with_date.replace(
                    "{{ date }}",
                    formattedDate
                  )
                : "The stock will arrive on " + formattedDate)
            : (elementso.innerHTML = window.variantStrings.incoming
                ? window.variantStrings.incoming
                : "Stock in transit"),
          inventory_status.appendChild(elementso);
      }
    }
  }
  updateInventoryStatus(productTarget, variantQtyData) {
    if (!variantQtyData || !productTarget || !this.currentVariant) return;
    let qty = 0,
      im = !1,
      av = !1;
    variantQtyData
      .reduce((acc, item) => {
        const existingItem = acc.find((i) => i.option === item.option);
        return (
          existingItem
            ? ((existingItem.qty += item.qty),
              item.mamagement === "" && (existingItem.mamagement = ""),
              item.available === !0 && (existingItem.available = !0))
            : acc.push(item),
          acc
        );
      }, [])
      .find((variantQty) => {
        variantQty.option === this.currentVariant.option1 &&
          ((qty = variantQty.qty),
          (im = variantQty.mamagement),
          (av = variantQty.available));
      });
  }
  updateStockNotify(productTarget, variantQtyData) {
    if (!variantQtyData || !productTarget || !this.currentVariant) return;
    let qty = 0,
      im = !1,
      av = !1;
    variantQtyData
      .reduce((acc, item) => {
        const existingItem = acc.find((i) => i.option === item.option);
        return (
          existingItem
            ? ((existingItem.qty += item.qty),
              item.mamagement === "" && (existingItem.mamagement = ""),
              item.available === !0 && (existingItem.available = !0))
            : acc.push(item),
          acc
        );
      }, [])
      .find((variantQty) => {
        variantQty.option === this.currentVariant.option1 &&
          ((qty = variantQty.qty),
          (im = variantQty.mamagement),
          (av = variantQty.available));
      });
    const blockButton = productTarget.querySelector(".product__form-add-cart");
    if (!blockButton) return;
    const notifyBtn = blockButton.querySelector(".notify-btn-js");
    if (!notifyBtn) return;
    const buyBtn = blockButton.querySelector(".buy-btn-js");
    im === "shopify" && qty === 0 && av !== !0
      ? (buyBtn && buyBtn.classList.add("d-none"),
        notifyBtn.classList.remove("d-none"))
      : (buyBtn && buyBtn.classList.remove("d-none"),
        notifyBtn.classList.add("d-none"));
  }
  renderProductInfor(variantQtyData) {
    if (!this.currentVariant || !this.productTarget) return;
    let qty = 0,
      percent = 0,
      sale = !1,
      soldOut = !1,
      pre_order = !1,
      av = !1,
      im = !1;
    const compare_at_price = this.currentVariant.compare_at_price,
      price = this.currentVariant.price;
    variantQtyData
      .reduce((acc, item) => {
        const existingItem = acc.find((i) => i.option === item.option);
        return (
          existingItem
            ? ((existingItem.qty += item.qty),
              item.available === !0 && (existingItem.available = !0),
              item.mamagement === "" && (existingItem.mamagement = ""))
            : acc.push(item),
          acc
        );
      }, [])
      .find((variantQty) => {
        variantQty.option === this.currentVariant.option1 &&
          ((qty = variantQty.qty),
          (av = variantQty.available),
          (im = variantQty.mamagement));
      }),
      compare_at_price &&
        compare_at_price > price &&
        ((sale = !0),
        (percent = ((compare_at_price - price) / compare_at_price) * 100)),
      im === ""
        ? ((soldOut = !1), (pre_order = !1))
        : av && qty < 1
        ? (pre_order = !0)
        : av || (soldOut = !0),
      this.renderLabel(sale, pre_order, soldOut, percent);
  }
  checkSwatches(e) {
    const { color, image, hex } = e.dataset;
    color
      ? this.checkColor(color)
        ? ((e.style.backgroundColor = color),
          hex && (e.style.backgroundColor = hex))
        : hex
        ? (e.style.backgroundColor = hex)
        : image &&
          (e.classList.add("color__" + color.replace(/ /g, "-")),
          (e.style.backgroundColor = null),
          (e.style.backgroundImage = "url('" + image + "')"),
          (e.style.backgroundSize = "cover"),
          (e.style.backgroundRepeat = "no-repeat"))
      : image &&
        ((e.style.backgroundColor = null),
        (e.style.backgroundImage = "url('" + image + "')"),
        (e.style.backgroundSize = "cover"),
        (e.style.backgroundRepeat = "no-repeat"));
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {}
  updateVariantInput() {
    document
      .querySelectorAll(`#product-form-${this.dataset.section}`)
      .forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        (input.value = this.currentVariant.id),
          input.dispatchEvent(
            new Event("change", {
              bubbles: !0,
            })
          );
      });
  }
  renderBtnStatus(productTarget, im, av, qty) {
    if (!productTarget) return;
    let btn_add_cart = productTarget.querySelector(".product_submit_button");
    btn_add_cart &&
      btn_add_cart.querySelector(".btn-label") &&
      (im === null
        ? ((btn_add_cart.querySelector(".btn-label").innerHTML =
            window.variantStrings.addToCart),
          (btn_add_cart.disabled = !1))
        : av
        ? qty < 1
          ? ((btn_add_cart.querySelector(".btn-label").innerHTML =
              window.variantStrings.preOrder),
            (btn_add_cart.disabled = !1))
          : ((btn_add_cart.querySelector(".btn-label").innerHTML =
              window.variantStrings.addToCart),
            (btn_add_cart.disabled = !1))
        : ((btn_add_cart.querySelector(".btn-label").innerHTML =
            window.variantStrings.soldOut),
          (btn_add_cart.disabled = !0)));
    const inventory_status = productTarget.querySelector(".inventory_status");
    if (inventory_status) {
      const divProgress = inventory_status.querySelector(
        "inventory-progress-bar"
      );
      divProgress &&
        (im === "shopify"
          ? (divProgress.classList.remove("d-none"), divProgress.init(qty, av))
          : divProgress.classList.add("d-none"));
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    return (s.color = strColor), s.color == strColor;
  }
  mapUpdateVariantInput(target) {
    if (!target) return;
    const section_id = target.dataset.section;
    target
      .querySelectorAll(`#product-form-${section_id}`)
      .forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        (input.value = this.currentVariant.id),
          input.dispatchEvent(
            new Event("change", {
              bubbles: !0,
            })
          );
      });
  }
  setUnavailable() {
    if (!this.productTarget) return;
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!button) return;
    const addButton = button.querySelector('[name="add"]'),
      addButtonText = button.querySelector('[name="add"] > span'),
      price = document.getElementById(`price-${this.dataset.section}`);
    addButton &&
      ((addButtonText.textContent = window.variantStrings.unavailable),
      (addButton.disabled = !0),
      price && price.classList.add("visibility-hidden"));
  }
  mapSetUnavailable(target) {
    if (!target) return;
    const section_id = target.dataset.section;
    if (!section_id) return;
    const button = target.querySelector(`#product-form-${section_id}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]'),
      addButtonText = button.querySelector('[name="add"] > span'),
      price = document.getElementById(`price-${section_id}`);
    addButton &&
      ((addButtonText.textContent = window.variantStrings.unavailable),
      (addButton.disabled = !0),
      price && price.classList.add("visibility-hidden"));
  }
  mapUpdateVariantChecked(target) {
    if (!target) return;
    const variant_controller_radios =
        target.querySelector("variant-radios-page") ||
        target.querySelector("variant-radios-sticky"),
      variant_controller_selects =
        target.querySelector("variant-selects-sticky") ||
        target.querySelector("variant-selects-page");
    if (!variant_controller_radios && !variant_controller_selects) return;
    let variant_controller = null,
      is_select = !1;
    variant_controller_radios &&
      (variant_controller = variant_controller_radios),
      variant_controller_selects &&
        ((variant_controller = variant_controller_selects), (is_select = !0));
    const inputWrappers = Array.from(
        this.querySelectorAll(".product-form__input")
      ),
      inputWrappersDetail = Array.from(
        variant_controller.querySelectorAll(".product-form__input")
      );
    inputWrappers.forEach((option, index) => {
      const previousOptionSelected =
        inputWrappers[index].querySelector(":checked")?.value;
      let inputDetail = null;
      is_select != !0
        ? (inputDetail = Array.from(
            inputWrappersDetail[index].querySelectorAll("input")
          ))
        : (inputDetail = Array.from(
            inputWrappersDetail[index].querySelectorAll("option")
          ));
      const checkedInput = inputDetail.find(
        (e) => e.value === previousOptionSelected
      );
      checkedInput &&
        (is_select != !0
          ? (checkedInput.checked = !0)
          : (checkedInput.selected = !0));
    });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(":checked")?.value === variant.option1
      ),
      inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
          ...option.querySelectorAll('input[type="radio"], option'),
        ],
        previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked")?.value,
        availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  mapUpdateVariantStatuses(target) {
    if (!target) return;
    const variant_controller =
      target.querySelector("variant-radios-sticky") ||
      target.querySelector("variant-selects-sticky");
    if (!variant_controller) return;
    const selectedOptionOneVariants = variant_controller.variantData.filter(
      (variant) => this.querySelector(":checked")?.value === variant.option1
    );
    if (!variant_controller) return;
    const inputWrappersDetail = [
      ...variant_controller.querySelectorAll(".product-form__input"),
    ];
    inputWrappersDetail.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
          ...option.querySelectorAll('input[type="radio"], option'),
        ],
        previousOptionSelected =
          inputWrappersDetail[index - 1].querySelector(":checked")?.value,
        availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  mapUpdateMedia(target, is_sticky = !1, t) {
    if (target)
      if (is_sticky) {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        target.querySelector(".product__media img") &&
          target.querySelector(".product__media img").removeAttribute("srcset"),
          target.querySelector(".product__media img") &&
            target
              .querySelector(".product__media img")
              .setAttribute(
                "src",
                this.currentVariant.featured_media.preview_image.src
              );
      } else {
        if (
          !this.currentVariant.featured_media ||
          !this.currentVariant.featured_media.position
        )
          return;
        const section_id = target.dataset.section;
        if (target.querySelector(".is_variant_group")) {
          const arr = target.dataset.optionName.split(",");
          if (!t) return;
          let match = t.name.match(/\[(.*?)\]/);
          var val1;
          if (
            (match ? (val1 = match[1]) : (val1 = t.name),
            target.querySelector(".is_column"))
          ) {
            const mediaGalleries = document.querySelectorAll(
              `[id^="MediaGallery-${section_id}"]`
            );
            arr.includes(val1)
              ? mediaGalleries.forEach((mediaGallery) => {
                  const colorPosition = mediaGallery.dataset.colorPosition;
                  if (colorPosition) {
                    const filter_items = this.variantData.filter(
                        (item) => item[colorPosition] === t.value
                      ),
                      galleryGrid =
                        mediaGallery.querySelector(".gallery-grid-js");
                    if (!galleryGrid) return;
                    const content = document.createElement("div");
                    mediaGallery
                      .querySelector("template")
                      .content.querySelectorAll(".slider-image")
                      .forEach((image) => {
                        const alt = image.dataset.alt;
                        t.value == alt &&
                          content.appendChild(image.cloneNode(!0));
                      }),
                      !content.querySelector(".slider-image") &&
                        filter_items &&
                        mediaGallery
                          .querySelector("template")
                          .content.querySelectorAll(".slider-image")
                          .forEach((image) => {
                            const position = image.dataset.position;
                            filter_items.forEach((items) => {
                              items.featured_image.position == position &&
                                content.appendChild(image.cloneNode(!0));
                            });
                          }),
                      (galleryGrid.innerHTML = ""),
                      (galleryGrid.innerHTML = content.innerHTML),
                      window.innerWidth < 767 &&
                        galleryGrid
                          .closest("gallery-grid")
                          .actionResizeLazyLoad(galleryGrid, content);
                  }
                })
              : mediaGalleries.forEach((mediaGallery) =>
                  mediaGallery.setActiveMedia(
                    `${section_id}-${this.currentVariant.featured_media.id}`,
                    !0
                  )
                );
          } else {
            const slide = target.querySelector(
              "slide-section.slide-section-media"
            );
            if (!slide) return;
            if (arr.includes(val1))
              document
                .querySelectorAll(`[id^="MediaGallery-${section_id}"]`)
                .forEach((mediaGallery) => {
                  const colorPosition = mediaGallery.dataset.colorPosition;
                  if (colorPosition) {
                    const filter_items = this.variantData.filter(
                        (item) => item[colorPosition] === t.value
                      ),
                      thumbnailSlide = mediaGallery.querySelector(
                        "slide-section.slide-section-thumbnail"
                      );
                    if (!thumbnailSlide) return;
                    const content_thumb = document.createElement("div");
                    thumbnailSlide
                      .querySelector("template")
                      .content.querySelectorAll(".slider-thumbnail")
                      .forEach((image) => {
                        const alt = image.dataset.alt;
                        t.value == alt &&
                          content_thumb.appendChild(image.cloneNode(!0));
                      }),
                      !content_thumb.querySelector(".slider-thumbnail") &&
                        filter_items &&
                        thumbnailSlide
                          .querySelector("template")
                          .content.querySelectorAll(".slider-thumbnail")
                          .forEach((image) => {
                            const position = image.dataset.position;
                            filter_items.forEach((items) => {
                              items.featured_image.position == position &&
                                content_thumb.appendChild(image.cloneNode(!0));
                            });
                          }),
                      thumbnailSlide.destroy(),
                      (thumbnailSlide.slider = null),
                      (thumbnailSlide.querySelector(
                        ".slide-container"
                      ).innerHTML = ""),
                      (thumbnailSlide.querySelector(
                        ".slide-container"
                      ).innerHTML = content_thumb.innerHTML),
                      thumbnailSlide.initSlide();
                    const gallerySlide = mediaGallery.querySelector(
                      "slide-section.slide-section-media"
                    );
                    if (!gallerySlide) return;
                    const content = document.createElement("div");
                    gallerySlide
                      .querySelector("template")
                      .content.querySelectorAll(".slider-image")
                      .forEach((image) => {
                        const alt = image.dataset.alt;
                        t.value == alt &&
                          content.appendChild(image.cloneNode(!0));
                      }),
                      !content.querySelector(".slider-image") &&
                        filter_items &&
                        gallerySlide
                          .querySelector("template")
                          .content.querySelectorAll(".slider-image")
                          .forEach((image) => {
                            const position = image.dataset.position;
                            filter_items.forEach((items) => {
                              items.featured_image.position == position &&
                                content.appendChild(image.cloneNode(!0));
                            });
                          }),
                      gallerySlide.destroy(),
                      (gallerySlide.slider = null),
                      (gallerySlide.querySelector(
                        ".slide-container"
                      ).innerHTML = ""),
                      (gallerySlide.querySelector(
                        ".slide-container"
                      ).innerHTML = content.innerHTML),
                      gallerySlide.initSlide(),
                      gallerySlide.gotoFunction(0);
                  }
                });
            else {
              const slide_items = slide.querySelectorAll(".slider-image");
              if (slide_items.length == 0) return;
              slide_items.forEach((e, index) => {
                const mediaId = e.getAttribute("data-media-id");
                if (
                  mediaId &&
                  mediaId ===
                    `${section_id}-${this.currentVariant.featured_media.id}`
                ) {
                  slide.gotoFunction(index);
                  const thumb = target.querySelector(
                    "slide-section.slide-section-thumbnail"
                  );
                  if (!thumb) return;
                  thumb.gotoFunction(index);
                }
              });
            }
          }
          const media = document.querySelector(".feature-product-media");
          media &&
            (media.classList.contains("external_zoom") ||
            media.classList.contains("inner_zoom")
              ? Zoom.init()
              : media.classList.contains("lightbox") &&
                initPhotoSwipeFromDOM(".gallery-zoom"));
        } else if (target.querySelector(".is_column"))
          document
            .querySelectorAll(`[id^="MediaGallery-${section_id}"]`)
            .forEach((mediaGallery) =>
              mediaGallery.setActiveMedia(
                `${section_id}-${this.currentVariant.featured_media.id}`,
                !0
              )
            );
        else {
          const slide = target.querySelector(
            "slide-section.slide-section-media"
          );
          if (!slide) return;
          slide.gotoFunction(this.currentVariant.featured_media.position - 1);
          const thumb = target.querySelector(
            "slide-section.slide-section-thumbnail"
          );
          if (!thumb) return;
          thumb.gotoFunction(this.currentVariant.featured_media.position - 1);
        }
      }
  }
}
customElements.define("variant-radios", VariantSwatches);
class VariantRadios extends VariantSwatches {
  constructor() {
    super();
  }
  init() {
    const _this = this;
    this.querySelectorAll(".swatch-items-js").length &&
      this.querySelectorAll(".swatch-items-js").forEach((btn) => {
        _this.checkSwatches(btn);
      }),
      this.addEventListener("change", this.onVariantChange),
      this.closest(".product__item-js") &&
        _this.onSlideChange(this.closest(".product__item-js"));
  }
  onSlideChange(target) {
    const slide = target.querySelector("slide-section.slide-section-media");
    slide && slide.onSlideChange();
  }
  async updateVariantsSwatch(target) {
    const _this = this,
      sectionId = _this.dataset.section,
      url = _this.dataset.url;
    this.productTarget = target.closest(".product__item-js");
    const optionSelect = Array.from(_this.querySelectorAll("fieldset")).map(
        (fieldset) => {
          if (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            )
          )
            return Array.from(fieldset.querySelectorAll("input"))
              .find((radio) => radio.checked)
              .getAttribute("data-option-value-id");
        }
      ),
      params =
        optionSelect.length > 0
          ? `&option_values=${optionSelect.join(",")}`
          : "";
    await fetch(`${url}?section_id=${sectionId}${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        (_this.querySelector(".variantJson").innerHTML =
          html.querySelector(".variantJson").innerHTML),
          (this.productTarget.querySelector(
            ".product__submit-form-js"
          ).innerHTML = html.querySelector(
            ".product__submit-form-js"
          ).innerHTML);
      }),
      (this.variantData = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      ));
  }
  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    await this.updateVariantsSwatch(target),
      (this.productTarget = target.closest(".product__item-js"));
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent
    );
    this.updateOptions();
    const currentVariant = this.updateMasterId(this.variantData);
    this.updateVariantStatuses(),
      currentVariant
        ? (this.updateMedia(),
          this.updatePrice(this.productTarget),
          this.renderProductInfor(this.productTarget, variantQtyData),
          this.updateVariantInput(),
          this.updateShareUrl(),
          this.updateIncomingStatus(this.productTarget, variantQtyData),
          this.updateInventoryStatus(this.productTarget, variantQtyData))
        : this.setUnavailable();
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    pickUpAvailability &&
      (this.currentVariant && this.currentVariant.available
        ? pickUpAvailability.fetchAvailability(this.currentVariant.id)
        : (pickUpAvailability.removeAttribute("available"),
          (pickUpAvailability.innerHTML = "")));
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      if (
        Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        )
      )
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
    });
  }
  renderProductInfor(productTarget, variantQtyData) {
    if (!this.currentVariant || !productTarget) return;
    let qty = 0,
      percent = 0,
      sale = !1,
      soldOut = !1,
      pre_order = !1,
      av = this.currentVariant.available,
      sku = this.currentVariant.sku,
      im = this.currentVariant.inventory_management;
    const compare_at_price = this.currentVariant.compare_at_price,
      price = this.currentVariant.price;
    let avaiable = productTarget.querySelector(".available-value"),
      sku_area = productTarget.querySelector(".product__sku .sku_content"),
      option_value = productTarget.querySelectorAll(".option_value");
    option_value.length != 0 &&
      option_value.forEach((e, index) => {
        this.currentVariant[`option${index + 1}`] &&
          (e.innerHTML = this.currentVariant[`option${index + 1}`]);
      }),
      sku_area && (sku_area.innerHTML = sku || "N/A"),
      variantQtyData.find((variantQty) => {
        variantQty.id === this.currentVariant.id && (qty = variantQty.qty);
      }),
      compare_at_price &&
        compare_at_price > price &&
        ((sale = !0), (percent = compare_at_price - price)),
      im === null
        ? ((soldOut = !1),
          (pre_order = !1),
          avaiable && (avaiable.innerHTML = window.variantStrings.inStock))
        : av
        ? qty < 1
          ? ((pre_order = !0),
            avaiable && (avaiable.innerHTML = window.variantStrings.preOrder))
          : ((soldOut = !1),
            (pre_order = !1),
            avaiable && (avaiable.innerHTML = window.variantStrings.inStock),
            avaiable && (avaiable.innerHTML = window.variantStrings.inStock))
        : ((soldOut = !0),
          avaiable && (avaiable.innerHTML = window.variantStrings.outStock)),
      this.renderLabel(sale, pre_order, soldOut, percent, productTarget),
      this.renderBtnStatus(productTarget, im, av, qty);
  }
  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    if (
      (sale || pre_order || soldOut) &&
      !productTarget.querySelector(".product__badges")
    ) {
      var element = document.createElement("div");
      element.classList.add(
        "product__badges",
        "fs-small",
        "d-flex",
        "flex-wrap",
        "uppercase"
      ),
        productTarget.querySelector(".sale_badge") &&
          productTarget.querySelector(".sale_badge").appendChild(element);
    }
    const label = productTarget.querySelector(".product__badges");
    if (label) {
      const prd = Shopify.formatMoney(
          percent,
          themeGlobalVariables.settings.money_format
        ),
        dsale = label.querySelector(".product__badges-sale"),
        dsoldout = label.querySelector(".product__badges-sold-out"),
        dpreorder = label.querySelector(".product__badges-pre-order");
      if (sale)
        if (dsale)
          dsale.innerHTML = `${
            window.variantStrings.save ? window.variantStrings.save : "Save"
          } ${prd}`;
        else {
          var elementsale = document.createElement("div");
          elementsale.classList.add(
            "product__badges-sale",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementsale.innerHTML = `${
              window.variantStrings.save ? window.variantStrings.save : "Save"
            } ${prd}`),
            dsoldout
              ? label.insertBefore(elementsale, dsoldout)
              : dpreorder
              ? label.insertBefore(elementsale, dpreorder)
              : label.appendChild(elementsale);
        }
      else dsale?.remove();
      if (pre_order)
        if (dpreorder)
          dpreorder.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : "Pre-order";
        else {
          var elementpo = document.createElement("div");
          elementpo.classList.add(
            "product__badges-pre-order",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementpo.innerHTML = window.variantStrings.preOrder
              ? window.variantStrings.preOrder
              : "Pre-order"),
            label.appendChild(elementpo);
        }
      else dpreorder?.remove();
      if (soldOut)
        if (dsoldout)
          dsoldout.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : "Sold out";
        else {
          var elementso = document.createElement("div");
          elementso.classList.add(
            "product__badges-sold-out",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementso.innerHTML = window.variantStrings.soldOut
              ? window.variantStrings.soldOut
              : "Sold out"),
            label.appendChild(elementso);
        }
      else dsoldout?.remove();
    }
  }
  updateMedia(t) {
    if (!this.productTarget) return;
    const option_name = this.productTarget.dataset.optionName;
    if (option_name === void 0) return;
    const arr = option_name.split(",");
    if (
      !(
        !this.currentVariant.featured_media ||
        !this.currentVariant.featured_media.position
      )
    )
      if (this.productTarget.querySelector(".is_variant_group")) {
        if (this.productTarget.querySelector(".is_column")) {
          if (!t) return;
          arr.includes(t.name)
            ? document
                .querySelectorAll(
                  `[id^="MediaGallery-${this.dataset.section}"]`
                )
                .forEach((mediaGallery) => {
                  const colorPosition = mediaGallery.dataset.colorPosition;
                  if (colorPosition) {
                    const filter_items = this.variantData.filter(
                        (item) => item[colorPosition] === t.value
                      ),
                      galleryGrid =
                        mediaGallery.querySelector(".gallery-grid-js");
                    if (!galleryGrid) return;
                    const content = document.createElement("div");
                    mediaGallery
                      .querySelector("template")
                      .content.querySelectorAll(".slider-image")
                      .forEach((image) => {
                        const alt = image.dataset.alt;
                        t.value == alt &&
                          content.appendChild(image.cloneNode(!0));
                      }),
                      !content.querySelector(".slider-image") &&
                        filter_items &&
                        mediaGallery
                          .querySelector("template")
                          .content.querySelectorAll(".slider-image")
                          .forEach((image) => {
                            const position = image.dataset.position;
                            filter_items.forEach((items) => {
                              items.featured_image.position == position &&
                                content.appendChild(image.cloneNode(!0));
                            });
                          }),
                      (galleryGrid.innerHTML = ""),
                      (galleryGrid.innerHTML = content.innerHTML),
                      window.innerWidth < 767 &&
                        galleryGrid
                          .closest("gallery-grid")
                          .actionResizeLazyLoad(galleryGrid, content);
                  }
                })
            : document
                .querySelectorAll(
                  `[id^="MediaGallery-${this.dataset.section}"]`
                )
                .forEach((mediaGallery) =>
                  mediaGallery.setActiveMedia(
                    `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                    !0
                  )
                );
        } else {
          const slide = this.productTarget.querySelector(
            "slide-section.slide-section-media"
          );
          if (!slide || !t) return;
          if (arr.includes(t.name))
            document
              .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
              .forEach((mediaGallery) => {
                const colorPosition = mediaGallery.dataset.colorPosition;
                if (colorPosition) {
                  const filter_items = this.variantData.filter(
                      (item) => item[colorPosition] === t.value
                    ),
                    thumbnailSlide = mediaGallery.querySelector(
                      "slide-section.slide-section-thumbnail"
                    );
                  if (!thumbnailSlide) return;
                  const content_thumb = document.createElement("div");
                  thumbnailSlide
                    .querySelector("template")
                    .content.querySelectorAll(".slider-thumbnail")
                    .forEach((image) => {
                      const alt = image.dataset.alt;
                      t.value == alt &&
                        content_thumb.appendChild(image.cloneNode(!0));
                    }),
                    !content_thumb.querySelector(".slider-thumbnail") &&
                      filter_items &&
                      thumbnailSlide
                        .querySelector("template")
                        .content.querySelectorAll(".slider-thumbnail")
                        .forEach((image) => {
                          const position = image.dataset.position;
                          filter_items.forEach((items) => {
                            items.featured_image.position == position &&
                              content_thumb.appendChild(image.cloneNode(!0));
                          });
                        }),
                    thumbnailSlide.destroy(),
                    (thumbnailSlide.slider = null),
                    (thumbnailSlide.querySelector(
                      ".slide-container"
                    ).innerHTML = ""),
                    (thumbnailSlide.querySelector(
                      ".slide-container"
                    ).innerHTML = content_thumb.innerHTML),
                    thumbnailSlide.initSlide();
                  const gallerySlide = mediaGallery.querySelector(
                    "slide-section.slide-section-media"
                  );
                  if (!gallerySlide) return;
                  const content = document.createElement("div");
                  gallerySlide
                    .querySelector("template")
                    .content.querySelectorAll(".slider-image")
                    .forEach((image) => {
                      const alt = image.dataset.alt;
                      t.value == alt &&
                        content.appendChild(image.cloneNode(!0));
                    }),
                    !content.querySelector(".slider-image") &&
                      filter_items &&
                      gallerySlide
                        .querySelector("template")
                        .content.querySelectorAll(".slider-image")
                        .forEach((image) => {
                          const position = image.dataset.position;
                          filter_items.forEach((items) => {
                            items.featured_image.position == position &&
                              content.appendChild(image.cloneNode(!0));
                          });
                        }),
                    gallerySlide.destroy(),
                    (gallerySlide.slider = null),
                    (gallerySlide.querySelector(".slide-container").innerHTML =
                      ""),
                    (gallerySlide.querySelector(".slide-container").innerHTML =
                      content.innerHTML),
                    gallerySlide.initSlide(),
                    gallerySlide.gotoFunction(0);
                }
              });
          else {
            const slide_items = slide.querySelectorAll(".slider-image");
            if (slide_items.length == 0) return;
            slide_items.forEach((e, index) => {
              const mediaId = e.getAttribute("data-media-id");
              if (
                mediaId &&
                mediaId ===
                  `${this.dataset.section}-${this.currentVariant.featured_media.id}`
              ) {
                slide.gotoFunction(index);
                const thumb = this.productTarget.querySelector(
                  "slide-section.slide-section-thumbnail"
                );
                if (!thumb) return;
                thumb.gotoFunction(index);
              }
            });
          }
        }
        const media = document.querySelector(".feature-product-media");
        media &&
          (media.classList.contains("external_zoom") ||
          media.classList.contains("inner_zoom")
            ? Zoom.init()
            : media.classList.contains("lightbox") &&
              initPhotoSwipeFromDOM(".gallery-zoom"));
      } else if (this.productTarget.querySelector(".is_column"))
        document
          .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
          .forEach((mediaGallery) =>
            mediaGallery.setActiveMedia(
              `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
              !0
            )
          );
      else {
        const slide = this.productTarget.querySelector(
          "slide-section.slide-section-media"
        );
        if (!slide) return;
        slide.gotoFunction(this.currentVariant.featured_media.position - 1);
        const thumb = this.productTarget.querySelector(
          "slide-section.slide-section-thumbnail"
        );
        if (!thumb) return;
        thumb.gotoFunction(this.currentVariant.featured_media.position - 1);
      }
  }
}
customElements.define("variant-radios-detail", VariantRadios);
class VariantSelects extends VariantSwatches {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange.bind(this));
  }
  async updateVariantsSwatch(target) {
    const _this = this,
      sectionId = _this.dataset.section,
      url = _this.dataset.url;
    this.productTarget = target.closest(".product__item-js");
    const optionSelect = Array.from(_this.querySelectorAll("select"), (select) => {
    const opt = select.selectedOptions?.[0] || select.options[select.selectedIndex];
      return opt?.dataset?.optionValueId;
    }).filter(Boolean);

    const params =
    optionSelect.length > 0
      ? `&option_values=${encodeURIComponent(optionSelect.join(","))}`
      : "";
    await fetch(`${url}?section_id=${sectionId}${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        (_this.querySelector(".variantJson").innerHTML =
          html.querySelector(".variantJson").innerHTML),
          (this.productTarget.querySelector(
            ".product__submit-form-js"
          ).innerHTML = html.querySelector(
            ".product__submit-form-js"
          ).innerHTML);
      }),
      (this.variantData = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      ));
  }
  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    await this.updateVariantsSwatch(target),
      (this.productTarget = target.closest(".product__item-js"));
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent
    );
    this.updateOptions();
    const currentVariant = this.updateMasterId(this.variantData);
    this.updateVariantStatuses(),
      currentVariant
        ? (this.updateMedia(),
          this.updatePrice(this.productTarget),
          this.renderProductInfor(this.productTarget, variantQtyData),
          this.updateVariantInput(),
          this.updateShareUrl())
        : this.setUnavailable();
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    pickUpAvailability &&
      (this.currentVariant && this.currentVariant.available
        ? pickUpAvailability.fetchAvailability(this.currentVariant.id)
        : (pickUpAvailability.removeAttribute("available"),
          (pickUpAvailability.innerHTML = "")));
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }
  updateMedia(t) {
    if (!this.productTarget) return;
    const option_name = this.productTarget.dataset.optionName;
    if (option_name === void 0) return;
    const arr = option_name.split(",");
    if (
      !(
        !this.currentVariant.featured_media ||
        !this.currentVariant.featured_media.position
      )
    )
      if (this.productTarget.querySelector(".is_variant_group")) {
        if (!t) return;
        let match = t.name.match(/\[(.*?)\]/);
        if (!match) return;
        let val = match[1];
        if (this.productTarget.querySelector(".is_column"))
          arr.includes(val)
            ? document
                .querySelectorAll(
                  `[id^="MediaGallery-${this.dataset.section}"]`
                )
                .forEach((mediaGallery) => {
                  const colorPosition = mediaGallery.dataset.colorPosition;
                  if (colorPosition) {
                    const filter_items = this.variantData.filter(
                        (item) => item[colorPosition] === t.value
                      ),
                      galleryGrid =
                        mediaGallery.querySelector(".gallery-grid-js");
                    if (!galleryGrid) return;
                    const content = document.createElement("div");
                    mediaGallery
                      .querySelector("template")
                      .content.querySelectorAll(".slider-image")
                      .forEach((image) => {
                        const alt = image.dataset.alt;
                        t.value == alt &&
                          content.appendChild(image.cloneNode(!0));
                      }),
                      !content.querySelector(".slider-image") &&
                        filter_items &&
                        mediaGallery
                          .querySelector("template")
                          .content.querySelectorAll(".slider-image")
                          .forEach((image) => {
                            const position = image.dataset.position;
                            filter_items.forEach((items) => {
                              items.featured_image.position == position &&
                                content.appendChild(image.cloneNode(!0));
                            });
                          }),
                      (galleryGrid.innerHTML = ""),
                      (galleryGrid.innerHTML = content.innerHTML),
                      window.innerWidth < 767 &&
                        galleryGrid
                          .closest("gallery-grid")
                          .actionResizeLazyLoad(galleryGrid, content);
                  }
                })
            : document
                .querySelectorAll(
                  `[id^="MediaGallery-${this.dataset.section}"]`
                )
                .forEach((mediaGallery) =>
                  mediaGallery.setActiveMedia(
                    `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                    !0
                  )
                );
        else {
          const slide = this.productTarget.querySelector(
            "slide-section.slide-section-media"
          );
          if (!slide) return;
          if (arr.includes(val))
            document
              .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
              .forEach((mediaGallery) => {
                const colorPosition = mediaGallery.dataset.colorPosition;
                if (colorPosition) {
                  const filter_items = this.variantData.filter(
                      (item) => item[colorPosition] === t.value
                    ),
                    thumbnailSlide = mediaGallery.querySelector(
                      "slide-section.slide-section-thumbnail"
                    );
                  if (!thumbnailSlide) return;
                  const content_thumb = document.createElement("div");
                  thumbnailSlide
                    .querySelector("template")
                    .content.querySelectorAll(".slider-thumbnail")
                    .forEach((image) => {
                      const alt = image.dataset.alt;
                      t.value == alt &&
                        content_thumb.appendChild(image.cloneNode(!0));
                    }),
                    !content_thumb.querySelector(".slider-thumbnail") &&
                      filter_items &&
                      thumbnailSlide
                        .querySelector("template")
                        .content.querySelectorAll(".slider-thumbnail")
                        .forEach((image) => {
                          const position = image.dataset.position;
                          filter_items.forEach((items) => {
                            items.featured_image.position == position &&
                              content_thumb.appendChild(image.cloneNode(!0));
                          });
                        }),
                    thumbnailSlide.destroy(),
                    (thumbnailSlide.slider = null),
                    (thumbnailSlide.querySelector(
                      ".slide-container"
                    ).innerHTML = ""),
                    (thumbnailSlide.querySelector(
                      ".slide-container"
                    ).innerHTML = content_thumb.innerHTML),
                    thumbnailSlide.initSlide();
                  const gallerySlide = mediaGallery.querySelector(
                    "slide-section.slide-section-media"
                  );
                  if (!gallerySlide) return;
                  const content = document.createElement("div");
                  gallerySlide
                    .querySelector("template")
                    .content.querySelectorAll(".slider-image")
                    .forEach((image) => {
                      const alt = image.dataset.alt;
                      t.value == alt &&
                        content.appendChild(image.cloneNode(!0));
                    }),
                    !content.querySelector(".slider-image") &&
                      filter_items &&
                      gallerySlide
                        .querySelector("template")
                        .content.querySelectorAll(".slider-image")
                        .forEach((image) => {
                          const position = image.dataset.position;
                          filter_items.forEach((items) => {
                            items.featured_image.position == position &&
                              content.appendChild(image.cloneNode(!0));
                          });
                        }),
                    gallerySlide.destroy(),
                    (gallerySlide.slider = null),
                    (gallerySlide.querySelector(".slide-container").innerHTML =
                      ""),
                    (gallerySlide.querySelector(".slide-container").innerHTML =
                      content.innerHTML),
                    gallerySlide.initSlide(),
                    gallerySlide.gotoFunction(0);
                }
              });
          else {
            const slide_items = slide.querySelectorAll(".slider-image");
            if (slide_items.length == 0) return;
            slide_items.forEach((e, index) => {
              const mediaId = e.getAttribute("data-media-id");
              if (
                mediaId &&
                mediaId ===
                  `${this.dataset.section}-${this.currentVariant.featured_media.id}`
              ) {
                slide.gotoFunction(index);
                const thumb = this.productTarget.querySelector(
                  "slide-section.slide-section-thumbnail"
                );
                if (!thumb) return;
                thumb.gotoFunction(index);
              }
            });
          }
        }
        const media = document.querySelector(".feature-product-media");
        media &&
          (media.classList.contains("external_zoom") ||
          media.classList.contains("inner_zoom")
            ? Zoom.init()
            : media.classList.contains("lightbox") &&
              initPhotoSwipeFromDOM(".gallery-zoom"));
      } else if (this.productTarget.querySelector(".is_column"))
        document
          .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
          .forEach((mediaGallery) =>
            mediaGallery.setActiveMedia(
              `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
              !0
            )
          );
      else {
        const slide = this.productTarget.querySelector(
          "slide-section.slide-section-media"
        );
        if (!slide) return;
        slide.gotoFunction(this.currentVariant.featured_media.position - 1);
        const thumb = this.productTarget.querySelector(
          "slide-section.slide-section-thumbnail"
        );
        if (!thumb) return;
        thumb.gotoFunction(this.currentVariant.featured_media.position - 1);
      }
  }
  renderProductInfor(productTarget, variantQtyData) {
    if (!this.currentVariant || !productTarget) return;
    let qty = 0,
      percent = 0,
      sale = !1,
      soldOut = !1,
      pre_order = !1,
      av = this.currentVariant.available,
      im = this.currentVariant.inventory_management;
    const compare_at_price = this.currentVariant.compare_at_price,
      price = this.currentVariant.price;
    let avaiable = productTarget.querySelector(".available-value"),
      sku = this.currentVariant.sku,
      sku_area = productTarget.querySelector(".product__sku .sku_content");
    sku_area && (sku_area.innerHTML = sku || "N/A");
    let option_value = productTarget.querySelectorAll(".option_value");
    option_value.length != 0 &&
      option_value.forEach((e, index) => {
        this.currentVariant[`option${index + 1}`] &&
          (e.innerHTML = this.currentVariant[`option${index + 1}`]);
      }),
      variantQtyData.find((variantQty) => {
        variantQty.id === this.currentVariant.id && (qty = variantQty.qty);
      }),
      variantQtyData.find((variantQty) => {
        variantQty.id === this.currentVariant.id && (qty = variantQty.qty);
      }),
      compare_at_price &&
        compare_at_price > price &&
        ((sale = !0), (percent = compare_at_price - price)),
      im === null
        ? ((soldOut = !1),
          (pre_order = !1),
          avaiable && (avaiable.innerHTML = window.variantStrings.inStock))
        : av
        ? qty < 1
          ? ((pre_order = !0),
            avaiable && (avaiable.innerHTML = window.variantStrings.preOrder))
          : ((soldOut = !1),
            (pre_order = !1),
            avaiable && (avaiable.innerHTML = window.variantStrings.inStock),
            avaiable && (avaiable.innerHTML = window.variantStrings.inStock))
        : ((soldOut = !0),
          avaiable && (avaiable.innerHTML = window.variantStrings.outStock)),
      this.renderLabel(sale, pre_order, soldOut, percent, productTarget),
      this.renderBtnStatus(productTarget, im, av, qty);
  }
  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    if (
      (sale || pre_order || soldOut) &&
      !productTarget.querySelector(".product__badges")
    ) {
      var element = document.createElement("div");
      element.classList.add(
        "product__badges",
        "fs-small",
        "d-flex",
        "flex-wrap",
        "uppercase"
      ),
        productTarget.querySelector(".sale_badge") &&
          productTarget.querySelector(".sale_badge").appendChild(element);
    }
    const label = productTarget.querySelector(".product__badges");
    if (label) {
      const prd = Shopify.formatMoney(
          percent,
          themeGlobalVariables.settings.money_format
        ),
        dsale = label.querySelector(".product__badges-sale"),
        dsoldout = label.querySelector(".product__badges-sold-out"),
        dpreorder = label.querySelector(".product__badges-pre-order");
      if (sale)
        if (dsale)
          dsale.innerHTML = `${
            window.variantStrings.save ? window.variantStrings.save : "Save"
          } ${prd}`;
        else {
          var elementsale = document.createElement("div");
          elementsale.classList.add(
            "product__badges-sale",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementsale.innerHTML = `${
              window.variantStrings.save ? window.variantStrings.save : "Save"
            } ${prd}`),
            dsoldout
              ? label.insertBefore(elementsale, dsoldout)
              : dpreorder
              ? label.insertBefore(elementsale, dpreorder)
              : label.appendChild(elementsale);
        }
      else dsale?.remove();
      if (pre_order)
        if (dpreorder)
          dpreorder.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : "Pre-order";
        else {
          var elementpo = document.createElement("div");
          elementpo.classList.add(
            "product__badges-pre-order",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementpo.innerHTML = window.variantStrings.preOrder
              ? window.variantStrings.preOrder
              : "Pre-order"),
            label.appendChild(elementpo);
        }
      else dpreorder?.remove();
      if (soldOut)
        if (dsoldout)
          dsoldout.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : "Sold out";
        else {
          var elementso = document.createElement("div");
          elementso.classList.add(
            "product__badges-sold-out",
            "d-inline-flex",
            "middle-center",
            "heading-weight",
            "text-center"
          ),
            (elementso.innerHTML = window.variantStrings.soldOut
              ? window.variantStrings.soldOut
              : "Sold out"),
            label.appendChild(elementso);
        }
      else dsoldout?.remove();
    }
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadiosPage extends VariantRadios {
  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    await this.updateVariantsSwatch(target);
    const sticky =
      document.querySelector("variant-radios-sticky") ||
      document.querySelector("variant-selects-sticky");
    sticky && (this.stickyTarget = sticky.closest(".product__item-js")),
      (this.productTarget = target.closest(".product__item-js"));
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent
    );
    this.updateOptions();
    const currentVariant = this.updateMasterId(this.variantData);
    this.updateVariantStatuses(),
      this.updatePickupAvailability(),
      currentVariant
        ? (this.updateMedia(e.target),
          this.mapUpdateMedia(this.stickyTarget, !0),
          this.updatePrice(this.productTarget),
          this.updatePrice(this.stickyTarget),
          this.renderProductInfor(this.productTarget, variantQtyData),
          this.renderProductInfor(this.stickyTarget, variantQtyData),
          this.updateVariantInput(),
          this.mapUpdateVariantInput(this.stickyTarget),
          this.mapUpdateVariantChecked(this.stickyTarget),
          this.updateURL(),
          this.updateShareUrl(),
          this.updateIncomingStatus(this.productTarget, variantQtyData),
          this.updateInventoryStatus(this.productTarget, variantQtyData),
          this.updateStockNotify(this.productTarget, variantQtyData))
        : (this.setUnavailable(),
          this.mapSetUnavailable(this.stickyTarget),
          this.mapUpdateVariantChecked(this.stickyTarget)),
      this.mapUpdateVariantStatuses(this.stickyTarget);
  }
}
customElements.define("variant-radios-page", VariantRadiosPage);
class VariantSelectsPage extends VariantSelects {
  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    await this.updateVariantsSwatch(target);
    const sticky =
      document.querySelector("variant-radios-sticky") ||
      document.querySelector("variant-selects-sticky");
    sticky && (this.stickyTarget = sticky.closest(".product__item-js")),
      (this.productTarget = target.closest(".product__item-js"));
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent
    );
    this.updateOptions();
    const currentVariant = this.updateMasterId(this.variantData);
    this.updateVariantStatuses(),
      this.updatePickupAvailability(),
      currentVariant
        ? (this.updateMedia(e.target),
          this.mapUpdateMedia(this.stickyTarget, !0),
          this.updatePrice(this.productTarget),
          this.updatePrice(this.stickyTarget),
          this.renderProductInfor(this.productTarget, variantQtyData),
          this.renderProductInfor(this.stickyTarget, variantQtyData),
          this.updateVariantInput(),
          this.mapUpdateVariantInput(this.stickyTarget),
          this.mapUpdateVariantChecked(this.stickyTarget),
          this.updateURL(),
          this.updateShareUrl(),
          this.updateIncomingStatus(this.productTarget, variantQtyData),
          this.updateInventoryStatus(this.productTarget, variantQtyData),
          this.updateStockNotify(this.productTarget, variantQtyData))
        : (this.mapUpdateVariantChecked(this.stickyTarget),
          this.setUnavailable(),
          this.mapSetUnavailable(this.stickyTarget)),
      this.mapUpdateVariantStatuses(this.stickyTarget);
  }
}
customElements.define("variant-selects-page", VariantSelectsPage);
class VariantRadiosSticky extends VariantRadios {
  constructor() {
    super();
  }
  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    await this.updateVariantsSwatch(target);
    const master =
      document.querySelector("variant-radios-page") ||
      document.querySelector("variant-selects-page");
    (this.masterTarget = master.closest(".product__item-js")),
      (this.productTarget = target.closest(".product__item-js"));
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent
    );
    this.updateOptions(),
      (this.currentVariant = this.updateMasterId(this.variantData)),
      this.updatePickupAvailability(),
      this.currentVariant
        ? (this.updateMedia(),
          this.mapUpdateMedia(this.masterTarget, !1, e.target),
          this.updatePrice(this.productTarget),
          this.updatePrice(this.masterTarget),
          this.renderProductInfor(this.productTarget, variantQtyData),
          this.renderProductInfor(this.masterTarget, variantQtyData),
          this.updateVariantInput(),
          this.mapUpdateVariantInput(this.masterTarget),
          this.mapUpdateVariantChecked(this.masterTarget),
          this.updateVariantStatuses(),
          this.mapUpdateVariantStatuses(this.masterTarget),
          this.updateURL(),
          this.updateShareUrl(),
          this.updateIncomingStatus(this.masterTarget, variantQtyData),
          this.updateInventoryStatus(this.masterTarget, variantQtyData),
          this.updateStockNotify(this.masterTarget, variantQtyData))
        : (this.mapUpdateVariantChecked(this.masterTarget),
          this.setUnavailable(),
          this.mapSetUnavailable(this.masterTarget));
  }
  updateMedia() {
    this.currentVariant &&
      this.currentVariant.featured_media &&
      (this.productTarget.querySelector(".product__media img") &&
        this.productTarget
          .querySelector(".product__media img")
          .removeAttribute("srcset"),
      this.productTarget.querySelector(".product__media img") &&
        this.productTarget
          .querySelector(".product__media img")
          .setAttribute(
            "src",
            this.currentVariant.featured_media.preview_image.src
          ));
  }
}
customElements.define("variant-radios-sticky", VariantRadiosSticky);
class VariantSelectsSticky extends VariantSelects {
  async onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    await this.updateVariantsSwatch(target);
    const master =
      document.querySelector("variant-radios-page") ||
      document.querySelector("variant-selects-page");
    (this.masterTarget = master.closest(".product__item-js")),
      (this.productTarget = target.closest(".product__item-js"));
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent
    );
    this.updateOptions();
    const currentVariant = this.updateMasterId(this.variantData);
    this.updateVariantStatuses(),
      this.mapUpdateVariantStatuses(this.masterTarget),
      this.updatePickupAvailability(),
      currentVariant
        ? (this.updateMedia(),
          this.mapUpdateMedia(this.masterTarget, !1, e.target),
          this.updatePrice(this.productTarget),
          this.updatePrice(this.masterTarget),
          this.renderProductInfor(this.productTarget, variantQtyData),
          this.renderProductInfor(this.masterTarget, variantQtyData),
          this.updateVariantInput(),
          this.mapUpdateVariantInput(this.masterTarget),
          this.mapUpdateVariantChecked(this.masterTarget),
          this.updateURL(),
          this.updateShareUrl(),
          this.updateIncomingStatus(this.masterTarget, variantQtyData),
          this.updateInventoryStatus(this.masterTarget, variantQtyData),
          this.updateStockNotify(this.masterTarget, variantQtyData))
        : (this.mapUpdateVariantChecked(this.masterTarget),
          this.setUnavailable(),
          this.mapSetUnavailable(this.masterTarget));
  }
  updateMedia() {
    this.currentVariant &&
      this.currentVariant.featured_media &&
      (this.productTarget.querySelector(".product__media img") &&
        this.productTarget
          .querySelector(".product__media img")
          .removeAttribute("srcset"),
      this.productTarget.querySelector(".product__media img") &&
        this.productTarget
          .querySelector(".product__media img")
          .setAttribute(
            "src",
            this.currentVariant.featured_media.preview_image.src
          ));
  }
}
customElements.define("variant-selects-sticky", VariantSelectsSticky);
class ProductRecommendations extends BaseSlide {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const __this = this,
      handleIntersection = (entries, observer) => {
        entries[0].isIntersecting &&
          (observer.unobserve(this),
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector(
                "product-recommendations"
              );
              recommendations &&
                recommendations.innerHTML.trim().length &&
                (this.innerHTML = recommendations.innerHTML),
                recommendations.innerHTML.trim().length === 0 && this.remove();
            })
            .finally(() => {
              initLazyloadItem(),
                __this.classList.contains("related-products-slide") &&
                !__this.classList.contains("complementary-products")
                  ? (__this.dataset?.freeScroll &&
                      (window.innerWidth <= 767
                        ? __this.initProgressBar()
                        : __this.initSlide()),
                    __this.onResize())
                  : __this.initSlide();
            })
            .catch((e) => {
              console.error(e);
            }));
      };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
  onResize() {
    const _this = this,
      has_item_mb = this.dataset?.freeScroll;
    let windowWidth = window.innerWidth,
      isMobile = windowWidth <= 767;
    window.addEventListener("resize", function () {
      const newWindowWidth = window.innerWidth,
        newIsMobile = newWindowWidth <= 767;
      newIsMobile !== isMobile &&
        ((windowWidth = newWindowWidth),
        (isMobile = newIsMobile),
        has_item_mb &&
          (isMobile
            ? (_this.destroy(), _this.initProgressBar())
            : (_this.removeProgressBar(), _this.destroy(), _this.initSlide())));
    });
  }
  destroy() {
    this.slider && (this.slider.destroy(), (this.slider = null));
  }
  removeProgressBar() {
    this.querySelector(".tns-progress") &&
      this.querySelector(".tns-progress").remove();
  }
  initProgressBar() {
    if (!this.querySelector(".tns-progress")) {
      var progressBarContainer = document.createElement("div");
      progressBarContainer.classList.add("tns-progress");
      var progressBar = document.createElement("div");
      progressBar.classList.add("tns-progress-bar"),
        (progressBar.style.width = "5%"),
        progressBarContainer.appendChild(progressBar),
        this.appendChild(progressBarContainer),
        setTimeout(() => {
          this.actionScrollBar();
        });
    }
  }
  actionScrollBar() {
    var container = this.querySelector(".slide-container");
    if (container) {
      var progressBar = this.querySelector(".tns-progress-bar");
      progressBar &&
        container.addEventListener("scroll", () => {
          const { scrollLeft, scrollWidth, clientWidth } = container,
            scrollPercentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
          scrollPercentage <= 100 &&
            (progressBar.style.width = `${scrollPercentage}%`),
            scrollPercentage <= 5 && (progressBar.style.width = "5%");
        });
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class ProductRecentlyViewed extends BaseSlide {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  initData() {
    var savedProductsArr = JSON.parse(
      localStorage.getItem("bl_recently-viewed-products")
    );
    this.getStoredProducts(savedProductsArr);
  }
  getStoredProducts(p) {
    const _this = this,
      limit = this.dataset?.limit;
    var query = "",
      productAjaxURL = "";
    p &&
      ([...p].reverse().forEach((e, key, pr) => {
        limit > key + 1 &&
          (Object.is(pr.length - 1, key)
            ? (query += e.id)
            : (query += e.id + "%20OR%20id:"));
      }),
      (productAjaxURL = "&q=id:" + query)),
      fetch(`${this.dataset.url}${productAjaxURL}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const items = html.querySelectorAll(".product-wrapper"),
            arrHtml = [];
          if (items.length > 0) {
            p.reverse().forEach((item) => {
              items.forEach((e) => {
                const itemId =
                  e.querySelector(".product__item-js")?.dataset.itemId;
                itemId && item.id == Number(itemId) && arrHtml.push(e);
              });
            });
            var node = document.createElement("div");
            const is_carousel = this.dataset.isCarousel;
            arrHtml.forEach((n) => {
              node.appendChild(n);
            }),
              is_carousel
                ? (node.classList.add("slide-container"),
                  (this.innerHTML = node.outerHTML))
                : (this.innerHTML = node.innerHTML);
          } else
            _this.closest(".section-recently-viewed-products") &&
              (_this
                .closest(".section-recently-viewed-products")
                .querySelector(".no-product")
                ?.classList.remove("d-none"),
              _this
                .closest(".section-recently-viewed-products")
                .querySelector("recently-viewed-products")
                ?.remove());
        })
        .finally(() => {
          initLazyloadItem(),
            _this.classList.contains("recently-viewed-products-slide") &&
              (_this.dataset?.freeScroll &&
                (window.innerWidth <= 767
                  ? _this.initProgressBar()
                  : _this.initSlide()),
              _this.onResize());
        })
        .catch((e) => {
          console.error(e);
        });
  }
  onResize() {
    const _this = this,
      has_item_mb = this.dataset?.freeScroll;
    let windowWidth = window.innerWidth,
      isMobile = windowWidth <= 767;
    window.addEventListener("resize", function () {
      const newWindowWidth = window.innerWidth,
        newIsMobile = newWindowWidth <= 767;
      newIsMobile !== isMobile &&
        ((windowWidth = newWindowWidth),
        (isMobile = newIsMobile),
        has_item_mb &&
          (isMobile
            ? (_this.destroy(), _this.initProgressBar())
            : (_this.removeProgressBar(), _this.destroy(), _this.initSlide())));
    });
  }
  destroy() {
    this.slider && (this.slider.destroy(), (this.slider = null));
  }
  removeProgressBar() {
    this.querySelector(".tns-progress") &&
      this.querySelector(".tns-progress").remove();
  }
  initProgressBar() {
    if (!this.querySelector(".tns-progress")) {
      var progressBarContainer = document.createElement("div");
      progressBarContainer.classList.add("tns-progress");
      var progressBar = document.createElement("div");
      progressBar.classList.add("tns-progress-bar"),
        (progressBar.style.width = "5%"),
        progressBarContainer.appendChild(progressBar),
        this.appendChild(progressBarContainer),
        setTimeout(() => {
          this.actionScrollBar();
        });
    }
  }
  actionScrollBar() {
    var container = this.querySelector(".slide-container");
    if (container) {
      var progressBar = this.querySelector(".tns-progress-bar");
      progressBar &&
        container.addEventListener("scroll", () => {
          const { scrollLeft, scrollWidth, clientWidth } = container,
            scrollPercentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
          scrollPercentage <= 100 &&
            (progressBar.style.width = `${scrollPercentage}%`),
            scrollPercentage <= 5 && (progressBar.style.width = "5%");
        });
    }
  }
  connectedCallback() {
    const __this = this,
      handleIntersection = (entries, observer) => {
        entries[0].isIntersecting &&
          (observer.unobserve(this), __this.initData());
      };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("recently-viewed-products", ProductRecentlyViewed);
